import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=cdaf4316&"
import script from "@/views/Dashboard/Dashboard.ts?vue&type=script&lang=ts&"
export * from "@/views/Dashboard/Dashboard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
